import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      className="border-t border-[var(--border)] bg-[var(--bg)]"
      data-testid={TESTIDS.footer}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="kbd-rule" />
              <span className="font-serif text-[26px] tracking-tight">
                Weston <span className="italic text-[var(--primary)]">Commercial</span>
              </span>
            </div>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-[var(--text-muted)]">
              A professional office park in the heart of Weston, Florida —
              built for small businesses, advisory firms and growing teams who
              expect more from their workspace.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow">Navigate</div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow">Specialty</div>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/industries" className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition font-semibold">
                  All 30 industries →
                </Link>
              </li>
              <li>
                <Link to="/office-space-for-attorneys-weston-fl" className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition">
                  Attorneys & law firms
                </Link>
              </li>
              <li>
                <Link to="/office-space-for-accountants-cpas-weston-fl" className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition">
                  Accountants & CPAs
                </Link>
              </li>
              <li>
                <Link to="/office-space-for-financial-advisors-weston-fl" className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition">
                  Financial advisors
                </Link>
              </li>
              <li>
                <Link to="/office-space-for-real-estate-brokers-weston-fl" className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition">
                  Real estate brokers
                </Link>
              </li>
              <li>
                <Link to="/office-space-near-i-75-weston" className="text-[14px] text-[var(--text-main)] hover:text-[var(--primary)] transition">
                  Office near I-75
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow">Leasing Office</div>
            <ul className="mt-5 space-y-4 text-[14px]">
              <li className="flex items-start gap-3">
                <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-[var(--primary)]" />
                <span className="text-[var(--text-main)]">
                  {BRAND.address.street}, {BRAND.address.suite}
                  <br />
                  {BRAND.address.city}, {BRAND.address.state} {BRAND.address.zip}
                </span>
              </li>
              <li>
                <a
                  href={`tel:${BRAND.phoneRaw}`}
                  className="inline-flex items-center gap-3 text-[var(--text-main)] hover:text-[var(--primary)]"
                >
                  <Phone size={16} strokeWidth={1.5} className="text-[var(--primary)]" />
                  {BRAND.phone}
                </a>
                <a
                  href={`tel:${BRAND.phoneSecondaryRaw}`}
                  className="block mt-1 ml-7 text-[13px] text-[var(--text-muted)] hover:text-[var(--primary)]"
                >
                  Alt · {BRAND.phoneSecondary}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="inline-flex items-center gap-3 text-[var(--text-main)] hover:text-[var(--primary)]"
                >
                  <Mail size={16} strokeWidth={1.5} className="text-[var(--primary)]" />
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-rule mt-16" />
        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-[var(--text-muted)]">
          <span>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</span>
          <span className="tracking-wider uppercase">
            Office Space Weston FL · Executive Suites · Office Rental Weston FL
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
